(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PlayIntegrityLogDetailController', PlayIntegrityLogDetailController);

    PlayIntegrityLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'PlayIntegrityLog'];

    function PlayIntegrityLogDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, PlayIntegrityLog) {
        var vm = this;

        vm.playIntegrityLog = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:playIntegrityLogUpdate', function(event, result) {
            vm.playIntegrityLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
